import { render, staticRenderFns } from "./Burger.vue?vue&type=template&id=cb90f294&"
import script from "./Burger.vue?vue&type=script&lang=js&"
export * from "./Burger.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./Burger.vue?vue&type=style&index=0&lang=sass&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  "766d3472"
  
)

export default component.exports